import { useEffect } from 'react';
import { Channel } from 'stream-chat';
import { useAtom } from 'jotai';

import { useChatClient } from '@bizzabo/chat-core';

import { View } from '../contexts/MessagesContext';
import { activeChannelIdAtom } from '../atoms';

interface useCreateChannelProps {
    setView: (view: View) => void;
}

const useCreateChannel = ({ setView }: useCreateChannelProps) => {
    const { client: chatClient, setActiveChannel } = useChatClient();
    const [activeChannelId, setActiveChannelId] = useAtom(activeChannelIdAtom);

    useEffect(() => {
        const fetchChannels = () => {
            const filters = {
                type: 'private',
                members: { $in: [chatClient.userID] },
                id: activeChannelId,
            };
            return chatClient.queryChannels(filters);
        };

        const redirectToActiveView = (channels: Channel[], activeChannelId: string) => {
            const newChannel = channels.find(channel => channel.id === activeChannelId);
            if (newChannel) {
                setActiveChannel(newChannel);
                setView(View.Channel);
            }
        };

        const changeView = async () => {
            if (activeChannelId) {
                const channels = Object.values(chatClient.activeChannels);
                const newChannel = channels.find(channel => channel.id === activeChannelId);

                if (newChannel) {
                    redirectToActiveView(channels, activeChannelId);
                } else {
                    const channels = await fetchChannels();
                    redirectToActiveView(channels, activeChannelId);
                }
                setActiveChannelId('');
            }
        };
        changeView();
    }, [activeChannelId, chatClient, setActiveChannel, setActiveChannelId]);
};

export default useCreateChannel;
